import type { ComponentProps, ComponentType } from 'react'
import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary'

const withErrorBoundary = (WrappedComponent: ComponentType) => {
  return (props: ComponentProps<typeof WrappedComponent>) => {
    return <ErrorBoundary>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  }
}

export default withErrorBoundary
